import type { LabelProps } from '@/components/control/components/label/label.types';
import clsx from 'clsx';
import '@/components/control/components/label/label.css';

export default function Label(props: LabelProps) {
  const { children, postion = 'idle', state = 'idle' } = props;
  return (
    <span
      className={clsx('control-label', {
        'control-label--position-idle': postion === 'idle',
        'control-label--position-active': postion === 'active',
        'control-label--state-idle': state === 'idle',
        'control-label--state-error': state === 'error',
        'control-label--state-success': state === 'success',
      })}
    >
      {children}
    </span>
  );
}
